import { REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN, REACT_APP__URL_EASYPOST_BASE, } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingPaymentProvider {
}
ApiEpBillingPaymentProvider.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/payment-provider`,
    method: "GET",
}).then((resp) => resp.filter((provider) => provider.id !== "qiwi" &&
    (provider.id !== "paddle" ||
        !!REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN)));
//# sourceMappingURL=payment_provider.js.map